import {FC, useEffect} from "react";
import styled from "@emotion/styled";
import {Outlet, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router";
import {fetchHelpJSONs} from "modules/actions";
import {getHelpContent, getTabs} from "modules/selectors";
import {buildHelpPathName} from "modules/utils";
import {Navigation} from "pages/help/Navigation";
import {Preloader} from "components";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 1240px;
	width: 100%;
	margin: 0 auto;
	gap: 20px;
	text-align: left;

	@media (min-width: 900px) {
		padding: 40px 20px;
		flex-direction: row;
	}
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;

	@media (min-width: 900px) {
		gap: 20px;
	}
`;

export const HelpLayout: FC = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const helpContent = useSelector(getHelpContent);
	const tabs = useSelector(getTabs);
	const {section} = useParams();

	useEffect(() => {
		dispatch(fetchHelpJSONs());
	}, [dispatch]);

	useEffect(() => {
		if (!section && tabs.length > 0) {
			navigate(buildHelpPathName(tabs[0].name));
		}
	}, [section, navigate, tabs]);

	if (!helpContent) {
		return <Preloader />;
	}

	return (
		<Wrapper>
			<Container>
				<Navigation />
				<Outlet />
			</Container>
		</Wrapper>
	);
};
